<template>
  <b-container fluid class="animated fadeIn">
    <div v-show="errorText !== ''" class="alert alert-danger" role="alert" dismissible @dismised="errorText = ''">
      {{$t(errorText)}}
    </div>
    <div v-show="success" class="alert alert-success" role="alert" dismissible @dismised="success=false">
      {{$t('La acción fue completada con éxito')}}
    </div>
    <b-row>
      <b-col md="6" class="mb-3">
          <b-form-group id="nombre"
            horizontal
            :label-cols="4"
            breakpoint="md"
            class="mb-0"
            :label="$t('Buscar')"
            :invalid-feedback="!isValidText(filterRules.text, false)? $t('No es un valor válido') : ''"
            :state="isValidText(filterRules.text, false)"
            :description="$t('Este campo de filtro realizará la busqueda en los nombres de los sellers')"
            label-for="nameFormatter">
            <b-input-group>
              <b-form-input :state="isValidText(filterRules.text, false)" id="nameFormatter" v-model="filterRules.text" :placeholder="$t('Texto a buscar')" />
              <b-input-group-button>
                <b-btn :disabled="!isValidText(filterRules.text, false)" @click="filterTable">{{$t('Buscar')}}</b-btn>
              </b-input-group-button>
            </b-input-group>
          </b-form-group>
        </b-col>
      <b-col md="6">
        <button class="btn btn-primary float-right mr-2" @click="openOrganizationModal(selected)">{{$t('Crear seller')}}</button>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col class="col-md-auto">
        <b-pagination :total-rows="totalRows" :per-page="filterRules.size" v-model="filterRules.from" class="mb-3" />
      </b-col>
      <b-col class="col-md-auto per-page">
        <b-form-group id="perPage" horizontal :label="$t('Mostrar por página')">
          <b-form-select :options="pageOptions" v-model="filterRules.size" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col class="mt-1" align-self="start">
        <b>{{totalRows}}</b> {{$t('sellers encontrados')}}
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-card header-bg-variant="primary" border-variant="primary" :header="$t('Lista de sellers')">
          <moon-loader :loading="loading" class="mb-2" color="#000" size="30px"></moon-loader>
          <b-table id="mainTable"
            ref="mainTable"
            show-empty
            striped
            hover
            foot-clone
            :sort-by.sync="filterRules.sortBy"
            :sort-desc.sync="filterRules.sortOrder"
            :per-page="filterRules.size"
            :current-page="filterRules.from"
            :items="itemProvider"
            :fields="fields"
            :filter="filter"
            :fixed=true
            responsive=true
            @row-clicked="openOrganizationModal"
            stacked="xl"
            :empty-text="$t('No hay sellers para mostrar')"
            :empty-filtered-text="$t('No hay sellers para mostrar')">
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      header-bg-variant="primary"
      ref="orgInfo"
      centered
      :title="selected.id ? $t('Guardar seller') : $t('Crear seller')"
      size="lg"
      @hidden="resetModal"
      @ok="handleSave"
      :cancel-title="$t('Cancelar')"
      :ok-title="selected.id ? $t('Guardar') : $t('Crear')"
      :ok-disabled="disableSave"
    >
      <b-container fluid>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              :label="$t('Nombre')"
              :invalid-feedback="!state.name? $t('El nombre es invalido') : ''"
              :state="state.name"
            >
              <b-form-input v-model="selected.name"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              :label="$t(labelSellerAccount)"
              :invalid-feedback="!state.accountName? $t('La cuenta es invalida o ya existe') : ''"
              :state="state.accountName"
            >
              <b-form-input :disabled="Boolean(selected.id)"
                v-model="selected.accountName"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              :label="$t('Razón social')"
              :invalid-feedback="!state.corporateName? $t('La razón social es inválida') : ''"
              :state="state.corporateName"
            >
              <b-form-input v-model="selected.corporateName"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              :label="$t('Email')"
              :invalid-feedback="!state.email? $t('El email es inválido') : ''"
              :state="state.email"
            >
              <b-form-input v-model="selected.email"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              :label="$t('Descripción')"
              :invalid-feedback="!state.description? $t('La descripción es invalida') : ''"
              :state="state.description"
            >
              <b-form-textarea
              :rows="3"
              :max-rows="6"
              v-model="selected.description"
              ></b-form-textarea>
            </b-form-group>
            <p class="counter">{{$t('Caracteres')}}: {{selected.description? selected.description.length : 0}} / 500</p>
          </b-col>
        </b-row>
        <div class="border-y py-3 my-3">
          <b-row>
            <b-col md="12">
              <div class="d-flex">
                <b>{{$t('Dirección')}}</b> 
                <div class="ml-3 circle" @click="toggleAddress">
                  <span v-show="showAddress"><i class="fas fa-minus"></i></span>
                  <span v-show="!showAddress"><i class="fas fa-plus"></i></span>
                </div>
              </div>
            </b-col>
          </b-row>
          <transition name="organizationlist">
            <b-row class="pt-3 mt-3 mb-4" v-if="showAddress">
              <b-col md="12">
                <b-form-group
                  horizontal
                  :label-cols="2"
                  :label="$t('Calle')"
                  :invalid-feedback="!state.street? $t('La calle es inválida') : ''"
                  :state="state.street"
                >
                  <b-form-input v-model="selected.addressInfo.street"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  horizontal
                  :label-cols="2"
                  :label="$t('Número')"
                  :invalid-feedback="!state.number? $t('El número es inválido') : ''"
                  :state="state.number"
                >
                  <b-form-input v-model="selected.addressInfo.number"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  horizontal
                  :label-cols="2"
                  :label="$t('Ciudad / Municipio')"
                  :invalid-feedback="!state.city? $t('La ciudad / municipio es inválida') : ''"
                  :state="state.city"
                >
                  <b-form-input v-model="selected.addressInfo.city"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12" v-if="neighborhood">
                <b-form-group
                  horizontal
                  :label-cols="2"
                  :label="$t('Colonia / Barrio')"
                  :invalid-feedback="!state.neighborhood? $t('La colonia / barrio es inválida') : ''"
                  :state="state.neighborhood"
                >
                  <b-form-input v-model="selected.addressInfo.neighborhood"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  horizontal
                  :label-cols="2"
                  :label="$t('Código postal')"
                  :invalid-feedback="!state.postalCode? $t('El código postal es inválido') : ''"
                  :state="state.postalCode"
                >
                  <b-form-input v-model="selected.addressInfo.postalCode"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  horizontal
                  :label-cols="2"
                  :label="$t('Estado_')"
                  :invalid-feedback="!state.state? $t('El estado es inválido') : ''"
                  :state="state.state"
                >
                  <b-form-input v-model="selected.addressInfo.state"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  horizontal
                  :label-cols="2"
                  :label="$t('Teléfono')"
                  :invalid-feedback="!state.phone? $t('El teléfono es inválido') : ''"
                  :state="state.phone"
                >
                  <b-form-input v-model="selected.addressInfo.phone"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </transition>
        </div>
        <b-row>
          <b-col offset-md="2">
            <b-img id="logo" thumbnail rounded fluid class="m-3 float-right"
              v-if="Boolean(selected.imageFile)"
              :src="selected.imageFile"
              />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              id="imageToUpload"
              :label-cols="2"
              breakpoint="md"
              :label="!Boolean(selected.imageFile) ? $t('Logo') : $t('Cambiar Logo')">
              <b-form-file
                ref="fileinput"
                v-model="file"
                accept="image/*"
                :placeholder="$t('Seleccione una imagen...')"
                :class="$i18n.locale">
              </b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              :label="$t('Términos y legales')"
              :invalid-feedback="!state.terms? $t('La descripción es invalida') : ''"
              :state="state.terms"
            >
              <b-form-textarea
              :rows="3"
              :max-rows="6"
              v-model="selected.terms"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>
<script>
  import { OrganizationService } from '@/mixims/AdminServiceMixin'
  import { ValidationsMixim } from '@/mixims/ValidationsMixim'
  import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
  import appConfig from '@/config/applicationConfig.js'

  export default {
    components: { MoonLoader },
    mixins: [OrganizationService, ValidationsMixim],
    data: function () {
      return {
        success: null,
        errorText: '',
        loading: false,
        fields: [
          { key: 'accountName', label: this.$t('Cuenta Vtex'), 'class': 'text-left', sortable: true },
          { key: 'name', label: this.$t('Nombre'), 'class': 'text-left', sortable: true },
          { key: 'description', label: this.$t('Descripción'), 'class': 'text-left', sortable: true }
        ],
        modal: {},
        selected: { addressInfo: {} },
        allSellers: null,
        file: null,
        filterRules: {
          sortBy: 'accountName',
          sortOrder: true,
          size: 10,
          from: 1,
          text: null
        },
        totalRows: 0,
        pageOptions: [ 10, 15, 25, 50, 100 ],
        showAddress: false
      }
    },
    methods: {
      filter () {
        return this.filterRules
      },
      handleSave () {
        let toSave = {...this.selected}
        let imgData = this.file ? {img: this.file} : null
        this.saveOrganization(toSave).then(
          (res) => {
            if (imgData) {
              return this.uploadImage(res.body.id, imgData.img).then(
                () => {
                  this.success = true
                  this.$refs.mainTable.refresh()
                }
              )
            } else {
              this.success = true
              this.$refs.mainTable.refresh()
            }
          },
          (error) => {
            this.errorText = error.body.message || 'Ocurrió un error el guardar la seller'
          }
        )
      },
      openOrganizationModal (org) {
        this.loading = true
        let _this = this
        this.errorText = ''
        this.success = false
        this.showAddress = false

        this.getAllOrganizations().then(
          (sellers) => {
            _this.loading = false
            _this.allSellers = sellers
            _this.selected = {...org}
            if (!_this.selected.addressInfo) _this.selected.addressInfo = {}
            _this.$refs.orgInfo.show()
          },
          () => {
            this.errorText = 'Error obteniendo el listado actualizado de Sellers'
          }
        )
      },
      resetModal () {
        this.showAddress = false
        this.selected = { addressInfo: {} }
        this.file = null
        this.allSellers = null
        this.$refs.fileinput.reset()
        this.$refs.mainTable.refresh()
      },
      filterTable () {
        this.$refs.mainTable.refresh()
      },
      itemProvider (ctx) {
        this.loading = true
        let filter = ctx.filter()
        return this.getOrganizations(filter).then(
          response => {
            this.totalRows = parseInt(response.headers.get('X-Total-Count'))
            this.loading = false
            return response.body
          },
          error => {
            this.errorText = error.body.message || 'Error obteniendo el listado de sellers'
            this.loading = false
            return []
          }
        )
      },
      uploadImage: function (id, img) {
        let formData = new FormData()
        let endPoint = `${appConfig.API_END_POINT}/admin/organization/${id}/image`
        formData.append('file', img)
        return this.$http.post(endPoint, formData, {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }).catch(() => {
          this.errorText = 'Ocurrio un error al cargar la imagen'
        })
      },
      existsSeller: function (seller) {
        return this.allSellers.find(itemSeller => itemSeller.accountName === seller)
      },
      toggleAddress () {
        this.showAddress = !this.showAddress
      },
      accountNameMaxChars () {
        return parseInt(process.env.VUE_APP_VTEX_ACCOUNT_MAX_CHARS)
      }
    },
    computed: {
      disableSave () {
        return Object.values(this.state).includes(false) || this.loading
      },
      state () {
        return {
          name: this.isValidText(this.selected.name, true, 41),
          accountName: Boolean(this.selected.id) || (this.isValidTextOneWord(this.selected.accountName, true, this.accountNameMaxChars()) && !this.existsSeller(this.selected.accountName)),
          corporateName: this.isValidText(this.selected.corporateName, true, 41),
          email: this.validateEmail(this.selected.email, true),
          description: this.isValidTextArea(this.selected.description, true, 500),
          terms: this.isValidTextArea(this.selected.terms, true),
          street: this.isValidText(this.selected.addressInfo && this.selected.addressInfo.street ? this.selected.addressInfo.street : '', false),
          number: this.isValidInteger(this.selected.addressInfo && this.selected.addressInfo.number ? this.selected.addressInfo.number : '', false),
          city: this.isValidText(this.selected.addressInfo && this.selected.addressInfo.city ? this.selected.addressInfo.city : '', false),
          state: this.isValidText(this.selected.addressInfo && this.selected.addressInfo.state ? this.selected.addressInfo.state : '', false),
          postalCode: this.isValidCP(this.selected.addressInfo && this.selected.addressInfo.postalCode ? this.selected.addressInfo.postalCode : '', false),
          phone: this.isValidText(this.selected.addressInfo && this.selected.addressInfo.phone ? this.selected.addressInfo.phone : '', false),
          neighborhood: this.isValidText(this.selected.addressInfo && this.selected.addressInfo.neighborhood ? this.selected.addressInfo.neighborhood : '', false)
        }
      },
      labelSellerAccount () {
        return process.env.VUE_APP_SELLER_ACCOUNT_LABEL
      },
      neighborhood () {
        return appConfig.NEIGHBORHOOD
      }
    }
  }
</script>
<style>
  .overflow-ellipsis {
    text-overflow: ellipsis;
  }
  #logo {
    width: 75px!important;
    height: 75px!important;
  }
  .counter {
    float: right;
    font-size: 10px;
    font-weight: 700;
    margin-bottom: 5px;
  }
  .circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid grey;
    background: whitesmoke;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .circle:hover {
    opacity: 0.6;
  }
  .organizationlist-enter-active, .organizationlist-leave-active {
    transition: all .5s;
  }

  .organizationlist-enter, .organizationlist-leave-to {
    margin: 0;
    padding: 0;
    opacity: 0;
  }
  .border-y {
    border-top: 1px solid #e3e8ec!important;
    border-bottom: 1px solid #e3e8ec!important;
  }
</style>
